import React from 'react';
import PropTypes from 'prop-types';
import Icon from 'chameleon/ui-stack/ui/base/icon';
import A11y from 'chameleon/ui-stack/utilities/a11y';

const SideBarToggle = (props) => {
  const { onToggle, isSideBarOpen } = props;
  const accessibility = {
    title: 'Menu',
    ariaHidden: 'true',
  };

  const onClick = () => {
    onToggle(!isSideBarOpen);
  };

  return (
    <A11y>
      <div
        className="ml-auto desktop:hidden mr-8.3 cursor-pointer"
        role="button"
        aria-label="Open the navigation"
        aria-expanded={isSideBarOpen}
        aria-controls="sidebar"
        tabIndex={0}
        onClick={onClick}
      >
        <Icon
          accessibility={accessibility}
          width="24"
          height="16"
          className="text-white"
          id={isSideBarOpen ? 'close' : 'menu'}
        />
      </div>
    </A11y>
  );
};

SideBarToggle.propTypes = {
  onToggle: PropTypes.func,
};

SideBarToggle.defaultProps = {
  onToggle: () => {},
};

export default SideBarToggle;
